import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { resolverHome } from '@/utils/homeRoute';

/**
 * Guard GLOBAL: intercepta toda e qualquer rota que comece com "/dashboard"
 * e redireciona professores/alunos puros para sua home, independente de como
 * a rota tenha sido registrada no Router (incluindo rotas adicionadas no
 * futuro, lazy, wildcards, etc.).
 *
 * Deve ser montado uma única vez, dentro do <BrowserRouter> e do AuthProvider,
 * acima das definições de <Routes>. Não renderiza nada.
 */
export const GlobalDashboardGuard: React.FC = () => {
  const { roles, rolesLoading, user, loading } = useAuth();
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || rolesLoading) return;
    if (!user) return;

    const ehRotaDashboard = pathname === '/dashboard' || pathname.startsWith('/dashboard/');
    if (!ehRotaDashboard) return;

    const isAdmin = roles.includes('admin');
    const isProfessor = roles.includes('professor');
    const isAluno = roles.includes('aluno');

    if (!isAdmin && (isProfessor || isAluno)) {
      const destino = resolverHome(roles);
      if (import.meta.env.DEV) {
        console.warn(
          `[GlobalDashboardGuard] Bloqueado acesso a ${pathname}${search}${hash} — redirecionando para ${destino}`,
        );
      }
      navigate(destino, { replace: true });
    }
  }, [pathname, search, hash, roles, rolesLoading, loading, user, navigate]);

  return null;
};
